import { Link } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import {
  CryptoIcon,
  CurrencyValue,
  DataTable,
  EtherScanPictogram,
  Flex,
  Heading,
  RelativeDateTime,
  WalletAddress
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function EventsTable({ data, sorting, pagination }) {
  const columns: TableColumn[] = [
    {
      header: 'Wallet Address',
      getCell: (row) => (
        <Link to={`/upgrade/usds/wallets/${row.wallet_address}`}>
          <WalletAddress
            address={row.wallet_address}
            options={{ name: row.wallet_name }}
          />
        </Link>
      )
    },
    {
      header: 'Caller Address',
      getCell: (row) => (
        <Link to={`/upgrade/usds/caller/${row.wallet_address}`}>
          <WalletAddress
            address={row.caller}
            options={{ name: row.caller_name }}
          />
        </Link>
      )
    },
    {
      header: 'Event',
      getCell: (row) => row.event
    },
    {
      header: (
        <Flex display="flex" flexDirection="row" alignItems="center" gap="3xs">
          Amount
          <CryptoIcon
            name="USDS"
            address={tokensMapping('USDS').address}
            size="0"
          />
        </Flex>
      ),
      getCell: (row) => (
        <CurrencyValue
          value={row.amount}
          options={{
            currency: '',
            trend: true,
            iconSize: '1'
          }}
        />
      ),
      cellAlign: 'flex-end',
      headerAlign: 'flex-end',
      sortingField: 'amount'
    },
    {
      header: 'Time',
      getCell: (row) => (
        <Flex gap={['xs', '2xs']} color="muted">
          <RelativeDateTime value={row.datetime} />
          <a
            href={`https://etherscan.io/tx/${row.tx_hash}`}
            target="_blank"
            rel="noreferrer">
            <EtherScanPictogram size="0" />
          </a>
        </Flex>
      ),
      cellAlign: 'flex-end',
      headerAlign: 'flex-end',
      sortingField: 'order_index'
    }
  ];

  return (
    <>
      <Flex justifyContent="space-between">
        <Heading size="2">Events</Heading>
      </Flex>
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index + row.wallet_address}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    </>
  );
}
